const pluralize = (value: number, unit: string, extension: string) => {
  return `${value} ${unit}${value !== 1 ? 's' : ''}${extension}`;
};

export const timeAgo = (date?: Date | string | undefined, extension: string = ' ago', def: string = '?'): string => {
  if (!date) return def;

  if (typeof date === 'string') date = new Date(date);

  if (isNaN(date.getTime())) return '?';

  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds === 0) return "just now";
  if (seconds < 60) return `${seconds} s${extension}`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return pluralize(minutes, 'min', extension);
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return pluralize(hours, 'hr', extension);
  const days = Math.floor(hours / 24);
  if (days < 7) return pluralize(days, 'dy', extension);
  const weeks = Math.floor(days / 7);
  if (days < 30) return pluralize(weeks, 'wk', extension);
  const months = Math.floor(days / 30);
  if (days < 365) return pluralize(months, 'mnth', extension);
  const years = Math.floor(days / 365);
  return pluralize(years, 'yr', extension);
}
